var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHumanIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2082 21.0938V19.0417C20.2082 17.9532 19.7758 16.9093 19.0061 16.1396C18.2364 15.3699 17.1925 14.9375 16.104 14.9375H7.89568C6.80719 14.9375 5.76327 15.3699 4.99359 16.1396C4.22391 16.9093 3.7915 17.9532 3.7915 19.0417V21.0938",
    stroke: "#525365",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9997 10.8334C14.2664 10.8334 16.1039 8.99585 16.1039 6.72918C16.1039 4.4625 14.2664 2.625 11.9997 2.625C9.73301 2.625 7.89551 4.4625 7.89551 6.72918C7.89551 8.99585 9.73301 10.8334 11.9997 10.8334Z",
    stroke: "#525365",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumanIcon);
export default __webpack_public_path__ + "static/media/HumanIcon.11979b40d04aaba22b91af4ba00d5dcd.svg";
export { ForwardRef as ReactComponent };